angular.module 'zc.projects'

.controller 'EditProjectCtrl', ($scope, $translate, Page, Project, currentProject) ->
  Page.setBodyClass ''
  $translate('projects.controllers.editController.changeSiteInformation').then (translation) ->
    Page.setTitle translation

  $scope.project = currentProject

  $scope.save = ->
    Project.update
      projectId: $scope.project.id
    , project:
        title: $scope.project.title

  $scope.updatePublish = (is_publish)->
    $scope.project.is_publish = is_publish
    Project.update
      projectId: $scope.project.id
    , project: {is_publish}



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects/controllers/edit_controller.js.coffee